import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegistrationFacade } from './facade/registration.facade';
import { RegistrationEffects } from './effects/registration.effects';
import { RegistrationReducers } from './reducers/index';
import { Features } from 'src/app/models/features';


@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(Features.REGISTRATION, RegistrationReducers),
    EffectsModule.forFeature([RegistrationEffects])
  ],
  providers: [RegistrationFacade]
})
export class RegistrationStoreModule { }
